export class ProveedorFilter {
   public rut: string;
   public razonSocial: string;
   public giro: string;
   public ciudad: string;
   public comuna: string;
   public emisorId: string;
   public tipoReferenciaId: string[];
   public activo: boolean;
}
